// extracted by mini-css-extract-plugin
module.exports = {"root":"MagicCards_root__bbFK9","content":"MagicCards_content___wtjl"};